import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CtaButton } from './CtaButton';
import { Lock, Mail, ShieldCheck } from 'lucide-react';
export const FinalCTA: React.FC = () => {
  const spotsTaken = 37;
  const totalSpots = 50;
  const percent = spotsTaken / totalSpots * 100;
  return <SectionWrapper className="bg-navy" id="comprar" data-id="element-41">
      <div className="max-w-4xl mx-auto text-center" data-id="element-42">
        <div className="mb-8" data-id="element-43">
          <span className="line-through text-gray-500 text-2xl md:text-3xl font-semibold mr-4" data-id="element-44">
            $47 USD
          </span>
          <span className="text-6xl md:text-7xl font-bold text-gold" data-id="element-45">
            $6.39 USD
          </span>
        </div>

        {/* Urgency Block */}
        <div className="max-w-2xl mx-auto mb-10 space-y-5" data-id="element-46">
          <p className="text-lg md:text-xl font-bold text-gold leading-snug" data-id="element-47">
            ⚠️ PRECIO DE LANZAMIENTO — Solo disponible para las primeras 50
            personas que compren durante el lanzamiento.
          </p>

          {/* Progress Bar */}
          <div className="space-y-2" data-id="element-48">
            <p className="text-red-500 font-bold text-base md:text-lg text-left" data-id="element-49">
              🔴 {spotsTaken} de {totalSpots} lugares tomados
            </p>
            <div className="w-full h-4 bg-navy-light border border-gray-700 rounded-full overflow-hidden" role="progressbar" aria-valuenow={spotsTaken} aria-valuemin={0} aria-valuemax={totalSpots} data-id="element-50">
              <div className="h-full bg-red-500 rounded-full transition-all duration-700" style={{
              width: `${percent}%`
            }} data-id="element-51"></div>
            </div>
          </div>

          <p className="text-sm md:text-base text-white leading-relaxed" data-id="element-52">
            Cuando se completen los 50 lugares el precio sube permanentemente a
            $17 USD. No hay excepciones.
          </p>
        </div>

        <div className="max-w-2xl mx-auto" data-id="element-53">
          <CtaButton text="SÍ, QUIERO MI PROTOCOLO VISA MASTER — ACCESO INMEDIATO POR $6.39 USD" data-id="element-54" />
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-6 mt-8 text-sm md:text-base text-gray-300 font-medium" data-id="element-55">
          <div className="flex items-center gap-2" data-id="element-56">
            <Lock size={20} className="text-gold" data-id="element-57" />
            <span data-id="element-58">Pago 100% Seguro</span>
          </div>
          <span className="hidden md:inline text-gray-600" data-id="element-59">•</span>
          <div className="flex items-center gap-2" data-id="element-60">
            <Mail size={20} className="text-gold" data-id="element-61" />
            <span data-id="element-62">PDF + Audio en tu correo en 5 minutos</span>
          </div>
          <span className="hidden md:inline text-gray-600" data-id="element-63">•</span>
          <div className="flex items-center gap-2" data-id="element-64">
            <ShieldCheck size={20} className="text-gold" data-id="element-65" />
            <span data-id="element-66">Garantía de 7 Días Sin Preguntas</span>
          </div>
        </div>
      </div>
    </SectionWrapper>;
};